import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { StoreKeys, initialState } from './maestroStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.IS_NAVIGATING_MAESTRO]: false,
  [StoreKeys.SET_IS_NAVIGATING_MAESTRO]: (isNavigatingMaestro: boolean) =>
    set({ isNavigatingMaestro }),
  [StoreKeys.MAESTRO_REQUEST_DATA]: {},
  [StoreKeys.SET_MAESTRO_REQUEST_DATA]: (maestroRequestData: any) =>
    set({ maestroRequestData }),
  [StoreKeys.CLEAR_MAESTRO_REQUEST_DATA]: () => set({ maestroRequestData: {} }),
  [StoreKeys.MAESTRO_RESPONSE_DATA]: {},
  [StoreKeys.SET_MAESTRO_RESPONSE_DATA]: (maestroResponseData: any) =>
    set({ maestroResponseData }),
  [StoreKeys.CLEAR_MAESTRO_RESPONSE_DATA]: () =>
    set({ maestroResponseData: {} }),
});

const maestroStore = persist(store, {
  name: 'maestroStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState, currentState) => ({
    ...currentState,
    ...persistedState,
  }),
}) as any;

export const useMaestroStore = create(devtools(maestroStore));
